




















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import DefaultWorkflowJob from '@/components/workflow/DefaultWorkflowJob.vue';
import { DocumentViewerConstants, NotificationConstants, EditReferencesButtonTooltipModel, DocumentSearchModel } from '@/types';
import { ScriveWorkflowJob, ObjectHelper } from '@/mixins';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ScriveWorkflowJob',
  mixins: [DefaultWorkflowJob, ScriveWorkflowJob, ObjectHelper],
  data() {
    return {
      leftPaneSize: 0,
      rightPaneSize: 0
    };
  },
  methods: {
    ...mapActions('scriveWorkflowJobStore', ['unloadScriveWorkflowJob']),
    onDeleteDocument(this: any, documentSearchModel: DocumentSearchModel) {
      this.reloadRelatedDocumentsTab(documentSearchModel);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['isWorkflowJobLocked', 'workflowDataSourceField', 'jobTabState']),
    ...mapGetters('scriveWorkflowJobStore', ['signersTab']),
    editReferencesTooltip(this: any): EditReferencesButtonTooltipModel | null {
      if (this.isWorkFlowJobDirty) {
        return {
          disabledTooltipMessage: NotificationConstants.CannotEditDocumentLinkedToUpdatedWorkflowJob,
          important: false
        };
      } else {
        return null;
      }
    }
  },
  mounted(this: any) {
    this.initializeCanGetNextJob();
  },
  beforeDestroy(this: any) {
    this.unloadScriveWorkflowJob();
  },
  components: {
    LoadingSpinner
  },
  created(this: any) {
    this.documentToolbarOptions = DocumentViewerConstants.DocumentViewerDeleteEnabledToolOptions;
  }
});
